export default {"src":"/_next/static/media/time.f8c6cd73.svg","height":71,"width":167,"blurWidth":0,"blurHeight":0};